import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    downloadAttachment: (idMessage, fileName) =>
      `${baseURL}/message/${idMessage}/attachment/download/${fileName}`,
    ensureMessageAttachment: idMessage =>
      `${baseURL}/message/${idMessage}/attachment/ensure`,
    uploadAttachment: idMessage =>
      `${baseURL}/message/${idMessage}/attachment/upload`
  }
})(process.env.FSP_URL)

/**
 * @description download a file as message attachment
 * @param {number} idMessage
 * @param {string} fileName
 * @returns
 */
export const fspApiDownloadAttachment = (idMessage, fileName) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.downloadAttachment(idMessage, fileName)
  }).then(extractApiData)
}

/**
 * @description ensure email attachments.
 * @param {number} idMessage
 * @param {Array<string>} fileNames
 * @returns
 */
export const fspApiEnsureMessageAttachment = (idMessage, fileNames) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.ensureMessageAttachment(idMessage),
    data: JSON.stringify(fileNames),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}

/**
 * @typedef {Object} UploadData
 * @property {string} FileName
 * @property {string} FileContent Base64 encoded file content
 *
 * @typedef {Object} OperationResult
 * @property {boolean} Result
 *
 * @description upload a file as message attachment.
 * @param {number} idMessage
 * @param {UploadData} data
 * @returns {OperationResult}
 */
export const fspApiUploadAttachment = (idMessage, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.uploadAttachment(idMessage),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}
